import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  Typography,
  colors,
} from "@mui/material";
import styled from "styled-components";
import { useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";

import { toast } from "react-toastify";

import { IndianCurrency, NumberInWord } from "app/utils/helper";
import dayjs from "dayjs";
import { THEME } from "app/config/constants";
import CustomLoader from "../common/CustomLoader";
import { getInvoice } from "app/services/org/collection.service";
import { LoadingButton } from "@mui/lab";
export default function Invoice() {
  const invoicePrintRef = useRef(null);
  const [data, setData] = useState({});
  const { invoiceId } = useParams();
  const handlePrint = useReactToPrint({
    content: () => invoicePrintRef.current,
  });
  const { isLoading: getInvoiceLoading, isFetching: getInvoiceFetching } =
    useQuery({
      queryKey: ["getInvoice", invoiceId],
      queryFn: () =>
        getInvoice({ invoiceNumber: String(invoiceId).replace(/ /g, "/") }),
      onSuccess: (value) => {
        setData(value?.data?.obj);
      },
      onError: (err) => {
        toast.error(err?.response?.data?.message);
      },
    });
  const InvoiceDetail = () => {
    return (
      <LeftSideDiv>
        <InvoiceHeader>Invoice</InvoiceHeader>
        <InvoiceBody>
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            Invoice No:{data?.invoiceNumber}
          </Typography>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            p={1}
            alignItems={"center"}
          >
            <Stack>
              <Typography className="title">Sold By:</Typography>
              <Typography>
                {data?.sellerDetail?.companyName ??
                  "Ekalsutra Edtech Private Limited"}
              </Typography>
              <Typography>
                {data?.sellerDetail?.address?.address ??
                  "Incubation Center, REC Ambedkar Nagar"}
                ,
              </Typography>
              <Typography>
                {data?.sellerDetail?.address?.dist ?? "Ambedkar Nagar"},{" "}
                {data?.sellerDetail?.address?.state ?? "Uttar Pradesh"},{" "}
                {data?.sellerDetail?.address?.pinCode ?? "224122"}
              </Typography>
              <Typography>
                GST : {data?.sellerDetail?.GST_Number ?? "--"}{" "}
              </Typography>
            </Stack>
            <Stack>
              <img
                alt="ekalsutra"
                src="/logo-blue.png"
                style={{ height: "70px", objectFit: "contain" }}
              />
            </Stack>
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            p={1}
            mx={1}
            alignItems={"center"}
            className="gray_box"
          >
            <Stack>
              <Typography className="title">Shipping Address</Typography>
              <Typography>{data?.schoolName}</Typography>
              <Typography>{data?.shippingAddress?.address},</Typography>
              <Typography>
                {data?.shippingAddress?.dist}, ({data?.shippingAddress?.state}),{" "}
                {data?.shippingAddress?.pinCode}
              </Typography>

              <Typography>GST : {data?.payerGST_Number ?? "--"}</Typography>
              <Typography>
                License Number:{" "}
                <span style={{ fontWeight: 600 }}>{data?.ekalRefNumber}</span>
              </Typography>
            </Stack>
            <Stack>
              <Typography className="title">Billing Address</Typography>
              <Typography>{data?.schoolName}</Typography>

              <Typography>{data?.billingAddress?.address},</Typography>
              <Typography>
                {data?.billingAddress?.dist}, ({data?.billingAddress?.state}),{" "}
                {data?.billingAddress?.pinCode}
              </Typography>
              <Typography>GST : </Typography>
            </Stack>
          </Stack>
          <Grid container className="orange_strip" columns={14} p={1}>
            <Grid item xs={4.5}>
              <Typography className="orange_strip__header">
                Description
              </Typography>
            </Grid>
            <Grid item xs={2.5}>
              <Typography className="orange_strip__header">
                HSN Detail
              </Typography>
            </Grid>
            {/* <Grid item xs={2}>
              <Typography className="orange_strip__header">Amount</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography className="orange_strip__header">Discount</Typography>
            </Grid> */}
            <Grid item xs={3}>
              <Typography className="orange_strip__header">
                Taxable Value
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography className="orange_strip__header">Tax</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography className="orange_strip__header">
                Total Amount
              </Typography>
            </Grid>
          </Grid>
          {data?.items?.map((item, ind) => (
            <Grid container columns={14} key={ind} px={1} mt={1}>
              <Grid item xs={4.5}>
                <Typography className="orange_strip__header">
                  {item?.productDetail?.productDescription ?? "--"}
                </Typography>
              </Grid>
              <Grid item xs={2.5}>
                <Typography className="orange_strip__header">
                  {item?.hsnCode} | GST:
                  {Number(item?.sgst ?? 0) +
                    Number(item?.sgst ?? 0) +
                    Number(item?.sgst ?? 0)}
                  %
                </Typography>
              </Grid>
              {/* <Grid item xs={2}>
                <Typography className="orange_strip__header">
                  {IndianCurrency(
                    Number(item?.orderDetail?.amount ?? 0) +
                      Number(item?.orderDetail?.discountAtpurchage ?? 0)
                  )}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className="orange_strip__header">
                  {IndianCurrency(item?.extraDiscountAmount)}
                </Typography>
              </Grid> */}
              <Grid item xs={3}>
                <Typography className="orange_strip__header">
                  {IndianCurrency(item?.taxableAmount)}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className="orange_strip__header">
                  {IndianCurrency(item?.taxAmount)}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className="orange_strip__header">
                  {IndianCurrency(item?.totalAmount)}
                </Typography>
              </Grid>
            </Grid>
          ))}

          <Box sx={{ backgroundColor: "#000", my: 0.3, height: "1px" }} />
          <Grid container sx={{ px: 1 }} columns={16}>
            <Grid item xs={12}>
              <Typography>
                <span style={{ fontWeight: 600 }}>Paid Amount:</span>{" "}
                {NumberInWord(Number(data?.totalPaidAmountWithTax).toFixed(0))}{" "}
                Rupees Only
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontWeight: 600 }}>
                {data?.paymentMode}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontWeight: 600 }}>
                {IndianCurrency(data?.totalPaidAmountWithTax)}
              </Typography>
            </Grid>
          </Grid>
          <Box sx={{ backgroundColor: "#000", my: 0.3, height: "1px" }} />
          <Stack direction="row" justifyContent="space-between" sx={{ px: 1 }}>
            <Box>
              <Typography>
                Created By : {data?.createdBy?.personName}
              </Typography>
              <Typography>
                Created On : {dayjs(data?.createdOn).format("DD MMM YYYY")}
              </Typography>
            </Box>
            <Box>
              <Typography>For,</Typography>
              <Typography>Ekalsutra Edtech Private Limited</Typography>
              <Typography sx={{ fontSize: "10px", pt: 5, pb: 1 }}>
                Authorised Sign.
              </Typography>
            </Box>
          </Stack>
        </InvoiceBody>
      </LeftSideDiv>
    );
  };

  return (
    <>
      <CustomLoader show={getInvoiceLoading || getInvoiceFetching} />
      <Box>
        <Stack
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={1}
        >
          <Button
            variant="contained"
            color="secondary"
            size="large"
            sx={{ mb: 1 }}
            onClick={() => {
              handlePrint();
            }}
          >
            Print
          </Button>
        </Stack>

        <Stack sx={{ width: "60%", m: "auto" }}>
          <InvoiceDetail />
          <Stack
            direction={"row"}
            gap={2}
            sx={{ mt: 2 }}
            justifyContent={"flex-end"}
          >
            <LoadingButton
              variant="contained"
              color="success"
              size="large"
              loading={getInvoiceLoading || getInvoiceFetching}
            >
              APPROVE
            </LoadingButton>
            <LoadingButton
              variant="contained"
              color="error"
              size="large"
              loading={getInvoiceLoading || getInvoiceFetching}
            >
              REJECT
            </LoadingButton>
          </Stack>
        </Stack>

        <Box sx={{ display: "none" }}>
          <Stack ref={invoicePrintRef} m={1}>
            <InvoiceDetail />
          </Stack>
        </Box>
      </Box>
    </>
  );
}

const LeftSideDiv = styled.div`
  margin: auto;
  width: 100%;
  height: 100%;
  border: 1px solid #00000073;
  background-color: #fff;
`;

const InvoiceHeader = styled.p`
  text-align: center;
  color: #fff;
  background-color: rgba(207, 54, 54, 1);
  margin: 0;
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  text-transform: capitalize;
  padding: 5px;
`;

const InvoiceBody = styled.div`
  .gray_box {
    border-radius: 15px;
    border: 1px solid #d0d0e2;
    background: rgba(208, 208, 226, 0.08);
  }
  .title {
    font-size: 16px;
    font-weight: 600;
  }
  .orange_strip {
    margin-bottom: 5px;
    background-color: #ffaf0d;
    margin-top: 15px;
    .orange_strip__header {
      font-size: 14px;
      font-weight: 600;
    }
  }
`;
